import API from "./api";
import { CleApiDto, CreerCleApiPayload } from "@/types/cle-api.types";

const CleApiService = {
  lister: async (): Promise<CleApiDto[]> => {
    const response = await API.get("/admin/cles-api");
    return response.data.donnees;
  },

  creer: async (payload: CreerCleApiPayload): Promise<CleApiDto> => {
    const response = await API.post("/admin/cles-api", payload);
    return response.data.donnees;
  },

  revoquer: async (id: number): Promise<CleApiDto> => {
    const response = await API.post(`/admin/cles-api/${id}/revoquer`);
    return response.data.donnees;
  },
};

export default CleApiService;
